<script>
  import {mapActions, mapGetters} from 'vuex'
  import DateSelect from './DateSelect.vue'
  import Labl from "@/components/Labl";

  let initialState = function () {
    return {
      ssnCode: null,
      ssnDate: null,
      ssnPriority: null,
      day: null,
      month: null,
      year: null,
    }
  }

  export default {
    name: 'SsnDetails',

    props: ['isCompleted', 'isReady'],

    components: {
      Labl,
      DateSelect
    },

    computed: {
      ...mapGetters(['getSsnPriorities', 'getLabel', 'getSsnData']),
    },

    mounted: function () {
      let ctx = this;
      this.eventHub.$on("resetAll", event => {
        ctx.reset(true);
      });
    },

    methods: {
      ...mapActions(['completeStep', 'setSsnData', 'resetStepsTo']),

      proceed: function () {
        this.$validator.validate().then(valid => {
          if (valid) {
            let ssnData = {
              ssnCode: this.ssnCode,
              ssnDate: this.ssnDate,
              ssnPriority: this.ssnPriority
            };

            this.setSsnData(ssnData);
            this.$analytics.pushEvent("impegnativa:step-completed");
            this.completeStep(4);
          }
        });
      },

      // GSD-586 change reset function for not delete ssnData
      reset: function (force) {
        if (!force) {
          this.resetStepsTo(4);
        }
      }
    },

    data: function () {
      return initialState()
    }
  }
</script>

<template>
  <div class="ssn-details wrap-step" :class="{uncompleted : !isReady, checked : isCompleted}">
    <h4>
      <Msg id="ospedali.form.ssndetails.title"/>
    </h4>

    <div v-if="!isCompleted && isReady">
      <div class="fieldset">
        <div>
          <Labl id="ospedali.form.ssndetails.code.label" for="id_code"/>
          <input id="id_code" v-model="ssnCode" data-vv-as=" " name="ssnCode" type="text" v-validate.disable="'required'" maxlength="20"/>
          <span class="error">{{ errors.first('ssnCode') }}</span>
        </div>

        <div>
          <Msg id="ospedali.form.ssndetails.priority.label"/>
          <v-select v-model="ssnPriority" data-vv-as=" " name="ssnPriority"
                    :placeholder="getLabel('ospedali.form.choose')"
                    :searchable="false" v-validate.disable="'required'" :options="getSsnPriorities"
                    :class="{ invalid: errors.has('ssnPriority')}" label="label">
          </v-select>
          <span class="error">{{ errors.first('ssnPriority') }}</span>
        </div>

        <div>
          <Msg id="ospedali.form.ssndetails.date.label"/>
          <DateSelect :selDay="day" @setDay="day=$event" :selMonth="month" @setMonth="month=$event" :selYear="year" @setYear="year=$event"
                      :class="{ invalid: errors.has('ssnDate')}"  data-vv-as=" "
                      v-model="ssnDate" :name="'ssnDate'"
                      v-validate.disable="'required|date_format:dd/MM/yyyy|before:'+ new Date().toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/[^ -~]/g,'') + ',true'"/>
          <span class="error">{{ errors.first('ssnDate') }}</span>
        </div>

      </div>


      <div class="wrap-main-cta">
        <button @click="proceed()" class="button-primary">
          {{getLabel('ospedali.form.button.proceeed')}}
        </button>
      </div>
    </div>


    <div v-else-if="isCompleted">
      <span> {{getSsnData.ssnCode}} </span>
      <button @click="reset(false)" class="button-text">
        {{getLabel("ospedali.form.button.modify")}}
      </button>
    </div>

  </div>
</template>